import { removeDataFromStorage } from '../../utils'
import { getCall, postCall } from '../../utils/apiCalls'
import { GET_ACCESS_TOKEN, GET_ALL_ROUTES_INFO, GET_ESCALATION_MATRIX } from '../../config/urls'
import { 
  TOKEN_SUCCESS, 
  LOGOUT_SUCCESS, 
  ALL_ROUTES_INFO,
  SET_MERCHANT_ID,
  SET_ESCALATION_MATRIX,
  SET_OPERATOR_TYPE
} from './actionTypes'
import { opdbGTM } from '../../utils/pulseUtils'
import moment from 'moment'

export const onLogout = () => {
  // clear all the localstorage data and redirect back to login page
  removeDataFromStorage();
  return { type: LOGOUT_SUCCESS }
}

export const getAccessToken = (sso_token_enc = '', dispatch) => {
  /*const access_code = code? code: localStorage.getItem('access-code');*/
  return postCall(GET_ACCESS_TOKEN, {}, true, { sso_token_enc })
    .then(res => {
      if (res && res.status === 200) {
        let loginDay = new Date();
        const modifiedDate = moment(loginDay).format('YYYY-MM-DD');
        // remove token from operator-details
        localStorage.setItem('operator-details', JSON.stringify(res.data || null));
        localStorage.setItem('access-token', res.data.access_token);
        // localStorage.setItem('access-token', sso_token_enc);
        localStorage.setItem('logged-in-data', modifiedDate);
        dispatch({
          type: TOKEN_SUCCESS,
          payload: res.data,
        });
        return res;
      } else {
        alert(res.response.data.message || 'Error occurred, please try later');
        // alert('Error, Please try again.');
        removeDataFromStorage();
        dispatch({
          type: LOGOUT_SUCCESS,
        });
      }
    })
}


export const getAllRoutesInfo = (query) => (dispatch) => {
  getCall(GET_ALL_ROUTES_INFO, query).then((res) => {
    if (res && res.status === 200) {
      localStorage.setItem("provider-id", res.data.data.provider_id);
      localStorage.setItem("operator-id", res.data.data.operator_id);
      if (res.data.data.provider_id == 16 && res.data.data.operator_id == 1) {
        dispatch({
          type: SET_OPERATOR_TYPE,
          payload: {
            isKsrtc: true,
            isApsrtc: false
          }
        })
      } else if (
        res.data.data.provider_id == 15 &&
        res.data.data.operator_id == 1
      ) {
        dispatch({
          type: SET_OPERATOR_TYPE,
          payload: {
            isKsrtc: false,
            isApsrtc: true
          }
        })
      }
      localStorage.setItem(
        "via-routes-support",
        res.data.data.via_route_support || false
      );
      localStorage.setItem(
        "download-support",
        res.data.data.service_download_support || false
      );
      opdbGTM.loggedIn(res.data.data.via_route_support);
      dispatch({
        type: ALL_ROUTES_INFO,
        payload: res.data.data || {},
      });
      return;
    }
    dispatch({
      type: SET_OPERATOR_TYPE,
      payload: {
        isKsrtc: false,
        isApsrtc: false
      }
    })
    let errorMsg = "Error Occurred, please try later.";
    if (
      res.response &&
      res.response.data &&
      res.response.data.message &&
      res.response.data.message.display
    )
      errorMsg = res.response.data.message.display;
    alert(errorMsg);
  })
};

export const setMerchantId = (merchantId) => dispatch => {
  dispatch({
    type: SET_MERCHANT_ID,
    payload: merchantId,
  })
}

export const getEscalationMatrixInfo = () => dispatch => {
  getCall(GET_ESCALATION_MATRIX)
    .then(res => {
      if(res && res.status === 200) {
        dispatch({
          type: SET_ESCALATION_MATRIX,
          payload: res.data || []
        })
        return;
      }
      let errorMsg = 'Error Occurred, please try later.';
      if(res && res.data && res.data.message)
        errorMsg = res.data.message;
      alert(errorMsg);
    })
}
